export default ({ app }, inject) => {
    // Only initialize on client side
    if (process.client) {
        const LaunchDarkly = require('launchdarkly-js-client-sdk').default

        const ldClient = LaunchDarkly.initialize(
            process.env.LAUNCHDARKLY_CLIENT_ID,
            {
                key: 'anonymous-user',
                anonymous: true
            }
        )

        const ld = {
            ready: ldClient.waitForInitialization(),
            getFlag: async (flagKey, defaultValue = false) => {
                await ldClient.waitForInitialization()
                return ldClient.variation(flagKey, defaultValue)
            },
            identify: (userData) => {
                ldClient.identify(userData)
            },
            client: ldClient
        }

        inject('ld', ld)
    } else {
        // Mock client for server-side
        inject('ld', {
            ready: Promise.resolve(),
            getFlag: async () => false,
            identify: () => { },
            client: {
                variation: () => false,
                identify: () => { },
                waitForInitialization: () => Promise.resolve()
            }
        })
    }
}